import types from './types';

const nextStateByType = {
  [types.SET_CONFIG_NAME]: (state, action) => action.payload.configName
}

const reducer = (state = null, action) => {
  const nextState = nextStateByType[action.type] || (state => state);
  return nextState(state, action);
};

export default reducer;
